import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EmptyReportSection from './EmptyReportSection';
import { numberOrZero } from './aiReportUtils';
import { reportStyles } from './styles';

export default function TopFailingFlowsTable({ topFailingFlows = [] }) {
  return (
    <Paper variant="outlined" sx={reportStyles.reportPaperWithMargin}>
      <Accordion disableGutters elevation={0}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Box>
            <Typography variant="subtitle1" sx={reportStyles.subsectionTitle}>
              Top Failing Flows
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Flows with the highest number of validation failures.
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          {topFailingFlows.length === 0 ? (
            <EmptyReportSection>No failing flows reported.</EmptyReportSection>
          ) : (
            <TableContainer>
              <Table size="small" aria-label="Top failing flows">
                <TableHead>
                  <TableRow>
                    <TableCell sx={reportStyles.tableHeaderCell}>Flow</TableCell>
                    <TableCell sx={reportStyles.tableHeaderCell}>Test Case</TableCell>
                    <TableCell align="right" sx={reportStyles.tableHeaderCell}>
                      Failures
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {topFailingFlows.map((item, index) => (
                    <TableRow key={`${item.flow_name || 'flow'}-${item.test_case || index}`}>
                      <TableCell sx={reportStyles.wordBreakCell}>
                        {item.flow_name || 'Unknown'}
                      </TableCell>
                      <TableCell sx={reportStyles.wordBreakCell}>
                        {item.test_case || 'N/A'}
                      </TableCell>
                      <TableCell align="right">{numberOrZero(item.total_failures)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
}
